"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuantityBreak = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var romanNumeralOne = 8560;
var QuantityBreak = exports.QuantityBreak = function QuantityBreak(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var focusClose = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (focusClose.current) {
      focusClose.current.focus();
    }
  }, [focusClose]);
  var qtyBreakRows = [];
  var qtyBreakFootnotes = [];
  var updatedQtyBreaks = props.quantityBreaks;
  var limitQtyCount = 0;
  var oncePerCustomerShown = false;
  if (props.baseOncePerCustomer && !oncePerCustomerShown) {
    qtyBreakFootnotes.push( /*#__PURE__*/_react["default"].createElement("div", {
      className: "footnote",
      key: "footnote_" + Math.random()
    }, String.fromCharCode(romanNumeralOne) + " " + props.couponCustomerLimitMessage));
    oncePerCustomerShown = true;
  }
  if (props.baseQtyLimit > 0) {
    limitQtyCount++;
  }
  var updateQtyBreakRows = function updateQtyBreakRows(item, i) {
    var updatedQB = props.qtyTier && props.qtyTier.length > 0 ? props.qtyTier : props.quantityBreaks;
    qtyBreakRows.push( /*#__PURE__*/_react["default"].createElement("tr", {
      className: "table-row-list",
      key: "row" + i
    }, /*#__PURE__*/_react["default"].createElement("td", {
      scope: "col"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "highlight"
    }), i !== updatedQB.length - 1 ? "".concat(item.quantity) : "".concat(item.quantity, "+")), /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: props.displayUnitPricing && props.individualUnitData ? "spacing-extra" : "spacing"
    }, "$", parseFloat(item.price).toFixed(2), item.oncePerCustomer && /*#__PURE__*/_react["default"].createElement("span", {
      className: "footnote-indicator"
    }, String.fromCharCode(romanNumeralOne)), item.footNoteString && /*#__PURE__*/_react["default"].createElement("span", {
      className: "footnote-indicator"
    }, item.footNoteString), " / ", props.itemIdentifier.unitId), !props.displayUnitPricing || !props.individualUnitData ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "saving-holder"
    }, "(", /*#__PURE__*/_react["default"].createElement("span", {
      className: "saving-label"
    }, "Save $", (props.unitPrice - parseFloat(item.price)).toFixed(2)), " ", "/", props.itemIdentifier.unitId, ")") : null)), props.displayUnitPricing && props.individualUnitData && props.individualUnitData.indivUnitCount !== 0 ? /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "spacing"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-weight-bold"
    }, "$", (parseFloat(item.price) / props.individualUnitData.indivUnitCount).toFixed(2), item.oncePerCustomer && /*#__PURE__*/_react["default"].createElement("span", {
      className: "footnote-indicator"
    }, String.fromCharCode(romanNumeralOne)), item.footNoteString && /*#__PURE__*/_react["default"].createElement("span", {
      className: "footnote-indicator"
    }, item.footNoteString)), " ", "/ ", props.individualUnitData.indivUnitLabel), /*#__PURE__*/_react["default"].createElement("div", {
      className: "saving-holder"
    }, "(", /*#__PURE__*/_react["default"].createElement("span", {
      className: "saving-label"
    }, "Save $", (props.unitPrice / props.individualUnitData.indivUnitCount - parseFloat(item.price) / props.individualUnitData.indivUnitCount).toFixed(2)), " ", "/", props.individualUnitData.indivUnitLabel, ")"))) : /*#__PURE__*/_react["default"].createElement("td", null)));
  };
  updatedQtyBreaks.forEach(function (qb) {
    if (qb.oncePerCustomer && !oncePerCustomerShown) {
      qtyBreakFootnotes.push( /*#__PURE__*/_react["default"].createElement("div", {
        className: "footnote",
        key: "footnote_" + Math.random()
      }, String.fromCharCode(romanNumeralOne) + " " + props.couponCustomerLimitMessage));
      oncePerCustomerShown = true;
    }
    if (qb.limitQty > 0) {
      limitQtyCount++;
      qb.footNoteString = String.fromCharCode(romanNumeralOne + limitQtyCount);
    }
  });
  if (props.qtyTier && props.qtyTier.length > 0) {
    var itemQtyBreaks = props.quantityBreaks.filter(function (qtyBreak) {
      return qtyBreak.itemNumber === props.itemIdentifier.id && qtyBreak.unitId === props.itemIdentifier.unitId;
    });
    var maxQtyItem = itemQtyBreaks.reduce(function (maxQtyItem, currentItem) {
      return currentItem.quantity > maxQtyItem.quantity ? currentItem : maxQtyItem;
    }, itemQtyBreaks[0]);
    updatedQtyBreaks = updatedQtyBreaks.filter(function (qb) {
      var _props$qtyTier;
      return (_props$qtyTier = props.qtyTier) === null || _props$qtyTier === void 0 ? void 0 : _props$qtyTier.includes(qb.quantity);
    });
    props.qtyTier.forEach(function (currentQtyTier) {
      var isQtyTierLessThanAll = currentQtyTier < props.quantityBreaks[0].quantity;
      var isInRange = props.quantityBreaks.some(function (qb, i) {
        var _props$quantityBreaks;
        return currentQtyTier > qb.quantity && i !== props.quantityBreaks.length - 1 && currentQtyTier < ((_props$quantityBreaks = props.quantityBreaks[i + 1]) === null || _props$quantityBreaks === void 0 ? void 0 : _props$quantityBreaks.quantity);
      });
      if (isQtyTierLessThanAll) {
        var qbPrice = parseFloat(props.unitPrice.toString()).toFixed(2);
        var currentQtyBreak = updatedQtyBreaks[0];
        updatedQtyBreaks.push(_objectSpread(_objectSpread({}, currentQtyBreak), {}, {
          limitQty: 0,
          oncePerCustomer: false,
          price: qbPrice,
          quantity: currentQtyTier,
          footNoteString: currentQtyBreak === null || currentQtyBreak === void 0 ? void 0 : currentQtyBreak.footNoteString
        }));
      } else if (isInRange) {
        var relevantQtyBreak = props.quantityBreaks.find(function (qb, i) {
          var _props$quantityBreaks2;
          return currentQtyTier >= qb.quantity && i !== props.quantityBreaks.length - 1 && currentQtyTier < ((_props$quantityBreaks2 = props.quantityBreaks[i + 1]) === null || _props$quantityBreaks2 === void 0 ? void 0 : _props$quantityBreaks2.quantity);
        });
        var _qbPrice = parseFloat(relevantQtyBreak.price).toFixed(2);
        updatedQtyBreaks.push(_objectSpread(_objectSpread({}, relevantQtyBreak), {}, {
          price: _qbPrice,
          quantity: currentQtyTier,
          footNoteString: relevantQtyBreak === null || relevantQtyBreak === void 0 ? void 0 : relevantQtyBreak.footNoteString
        }));
      } else if (currentQtyTier >= maxQtyItem.quantity && !updatedQtyBreaks.some(function (qb) {
        return qb.quantity === currentQtyTier;
      })) {
        var _qbPrice2 = parseFloat(maxQtyItem.price).toFixed(2);
        updatedQtyBreaks.push(_objectSpread(_objectSpread({}, maxQtyItem), {}, {
          price: _qbPrice2,
          quantity: currentQtyTier,
          footNoteString: maxQtyItem === null || maxQtyItem === void 0 ? void 0 : maxQtyItem.footNoteString
        }));
      }
    });
    updatedQtyBreaks.sort(function (a, b) {
      return a.quantity - b.quantity;
    });
  }
  updatedQtyBreaks.forEach(function (item, i) {
    item.footNoteString && qtyBreakFootnotes.push( /*#__PURE__*/_react["default"].createElement("div", {
      className: "footnote",
      key: "footnote_" + Math.random()
    }, item.footNoteString + " " + props.couponQtyLimitMessage.replace("[LimitQuantity]", item.limitQty.toString())));
    updateQtyBreakRows(item, i);
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "quantity-break-overlay"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "quantity-break"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "closeIcon",
    tabIndex: 0,
    onKeyPress: function onKeyPress(e) {
      return props.onClick(e);
    },
    onClick: function onClick(e) {
      return props.onClick(e);
    },
    ref: focusClose
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-block ".concat(qtyBreakFootnotes.length > 0 ? 'table-footnotes' : '')
  }, /*#__PURE__*/_react["default"].createElement("table", {
    className: "table"
  }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", {
    className: "table-row-header"
  }, /*#__PURE__*/_react["default"].createElement("th", null, "QTY"), /*#__PURE__*/_react["default"].createElement("th", null, "Price"), props.displayUnitPricing && props.individualUnitData && props.individualUnitData.indivUnitCount !== 0 ? /*#__PURE__*/_react["default"].createElement("th", null, "Unit Price") : /*#__PURE__*/_react["default"].createElement("td", null))), /*#__PURE__*/_react["default"].createElement("tbody", null, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, qtyBreakRows)))), qtyBreakFootnotes));
};
QuantityBreak.defaultProps = {
  baseQtyLimit: 0,
  couponCustomerLimitMessage: "Discount valid for 1 order per account",
  couponQtyLimitMessage: "Discount valid on orders of [LimitQuantity] or less."
};
//# sourceMappingURL=QuantityBreak.js.map